export default __webpack_public_path__ + "static/media/744.d78a6358.jpg";